import { render, staticRenderFns } from "./ShipmentStatusTable.vue?vue&type=template&id=434c8a36"
import script from "./ShipmentStatusTable.vue?vue&type=script&lang=js"
export * from "./ShipmentStatusTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports